import {
    normalizeFetchEstimatedAddFilesCostResponse,
    normalizeFetchEstimatedSimilarSubmissionsGenerationCostResponse,
    normalizeFetchSubmissionCriteriaDetailsResponse,
} from './utils/normalizers/semantic-language.normalizers'
import { PATTERN_TAG } from './utils/tags'
import baseApi from './base.api'

export const semanticLanguageApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        fetchEstimatedAddFilesCost: builder.query({
            query: ({ token, file }) => {
                const formData = new FormData()
                formData.append('zip_file', file)

                return {
                    url: `/nl-feedback/estimate-add-files-cost/${token}`,
                    method: 'POST',
                    body: formData,
                }
            },
            transformResponse: normalizeFetchEstimatedAddFilesCostResponse,
        }),
        fetchEstimatedSimilarSubmissionsGenerationCost: builder.query({
            query: ({ token, submissionId, numberOfSubmissionsToGenerate, layerId, patternId }) => ({
                url: `/nl-feedback/estimate-mutations-cost/${token}`,
                method: 'POST',
                body: {
                    submission_id: submissionId,
                    number_of_mutations: numberOfSubmissionsToGenerate,
                    layer_id: layerId,
                    pattern_id: patternId,
                },
            }),
            transformResponse: normalizeFetchEstimatedSimilarSubmissionsGenerationCostResponse,
        }),
        fetchSubmissionCriteriaDetails: builder.query({
            query: ({ token, layerId, submissionId }) => ({
                url: `/nl-feedback/${token}/${layerId}/reasoning/${submissionId}`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchSubmissionCriteriaDetailsResponse,
            providesTags: [{ type: PATTERN_TAG, id: 'LIST' }],
        }),
    }),
})

export const {
    useFetchEstimatedAddFilesCostQuery,
    useFetchEstimatedSimilarSubmissionsGenerationCostQuery,
    useFetchSubmissionCriteriaDetailsQuery,
} = semanticLanguageApi
